"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseResponsiveImage = exports.BaseImage = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _primitives = require("../../platform/primitives");

var _CleanTag = require("../CleanTag");

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-ignore

/**
 * Image component with space, width and height properties
 */
var BaseImage = (0, _styledComponents.default)(_CleanTag.CleanTag.as(_primitives.Image)).withConfig({
  displayName: "Imageshared__BaseImage",
  componentId: "sc-1dymtq1-0"
})(["", ";", ";", ";", ""], _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.borderRadius);
exports.BaseImage = BaseImage;

/**
 * An Image component that responsively resizes within its environment
 */
var BaseResponsiveImage = (0, _styledComponents.default)(_CleanTag.CleanTag).withConfig({
  displayName: "Imageshared__BaseResponsiveImage",
  componentId: "sc-1dymtq1-1"
})(["background:url(", ");background-size:contain;background-repeat:no-repeat;background-position:center;", ";", ";", ";", ";"], function (props) {
  return props.src;
}, _styledSystem.ratio, _styledSystem.space, _styledSystem.width, _styledSystem.maxWidth);
exports.BaseResponsiveImage = BaseResponsiveImage;
BaseResponsiveImage.defaultProps = {
  width: "100%",
  ratio: 1
};
//# sourceMappingURL=Image.shared.js.map